import { createTranslationRef, createTranslationResource } from '@backstage/core-plugin-api/alpha';

// -----------------------------------------------------------------------------------
// Textos de ayuda contextual (tooltips) de los formularios del scaffolder.
//
// Se mantienen en un ref propio (y no dentro de `scaffolder`) porque aquel está
// vinculado al `scaffolderTranslationRef` de Backstage, cuyo conjunto de claves es
// cerrado: no admite claves nuevas.
//
// Convención de claves: <goldenPath>.<campo>. Los custom fields genéricos
// (TooltipField) reciben la clave desde el `template.yaml` mediante
// `ui:options.tooltipKey`, así que al añadir un tooltip nuevo hay que declararlo
// aquí Y en los tres archivos (ref, -en, -es) para que TypeScript lo acepte.
// -----------------------------------------------------------------------------------

export const scaffolderTooltipsTranslationRef = createTranslationRef({
  id: 'scaffolder-tooltips',
  messages: {
    iacMvp: {
      application:
        'First hierarchical level on which an application is organised. It belongs to the owner of a business process or production unit, representing the processes and needs of the organisation.',
      applicationService:
        'Second hierarchical level of an application, sitting below a business application. It represents the technological solution that enables and supports the business processes covered by a business application.',
      catalog:
        'Company or business unit within Acciona that the infrastructure application to be deployed belongs to (Energía, Construcción, Corporación, Bestinver, Agua, etc). It is derived automatically from the selected application service, based on the information held in the CMDB. When the service has exactly one value it is set automatically and cannot be edited; otherwise a selector is shown, either with the values the CMDB provides for that service, or with a predefined list when the CMDB does not provide any.',
      environment:
        'Environment type of the infrastructure application to be deployed (Development, Integration, Pre-production, Production).',
      metal:
        'Metals (Platinum, Gold, Silver, Bronze) represent the criticality of an infrastructure application, its correspondence with the support level provided by the Operations supplier and the maximum incident resolution times. It applies to every infrastructure environment except development. The cost of that support varies with the criticality.',
      description:
        'Short functional description of the scope and functionality of the infrastructure application to be deployed.',
      hostname:
        'Unique name or label identifying the main endpoint of the application. This name is the same across every deployed environment of each application, with the environment itself as the distinguishing part (Development: hostname-dev.domain, Integration: hostname-int.domain, Pre-production: hostname-pre.domain, Production: hostname.domain).',
      domain:
        'Internal DNS (acciona.int, acciona-construccion.int, acciona-agua.int, etc) or external DNS (acciona.com, acciona-construccion.com, acciona-agua.com, etc) associated with the deployed application.',
    },
  },
});

export const scaffolderTooltipsTranslations = createTranslationResource({
  ref: scaffolderTooltipsTranslationRef,
  translations: {
    en: () => import('./scaffolder-tooltips-en'),
    es: () => import('./scaffolder-tooltips-es'),
  },
});
